export class QueryReducerState {
  prospectiveStudentsQuery: string;
  parentsOfProspectsQuery: string;
  otherQuery: string;
  usaQuery: string;
  internationalQuery: string;
  ageQuery: string;
  genderQuery: string;
  ethnicityQuery: string;
  intendedLevelOfStudyQuery: string;
  entryTermQuery: string;
  intendedMajorQuery: string;
  gpaQuery: string;
  testScoresQuery: string;
  dateRegisteredQuery: string;
  relativeEngagementQuery: string;
  totalTimeSpentQuery: string;
  scheduledVisitQuery: string;
  appliedQuery: string;
  activityWithInstitutionQuery: string;
  activityWithEABQuery: string;
  listMembershipQuery: string;
  locationsQuery: string;
  queryIsIncongruent: boolean;

  constructor(
    prospectiveStudentsQuery?: string,
    parentsOfProspectsQuery?: string,
    otherQuery?: string,
    usaQuery?: string,
    internationalQuery?: string,
    ageQuery?: string,
    genderQuery?: string,
    ethnicityQuery?: string,
    intendedLevelOfStudyQuery?: string,
    entryTermQuery?: string,
    intendedMajorQuery?: string,
    gpaQuery?: string,
    testScoresQuery?: string,
    dateRegisteredQuery?: string,
    relativeEngagementQuery?: string,
    totalTimeSpentQuery?: string,
    scheduledVisitQuery?: string,
    appliedQuery?: string,
    activityWithInstitutionQuery?: string,
    activityWithEABQuery?: string,
    listMembershipQuery?: string,
    locationsQuery?: string,
    queryIsIncongruent?: boolean
  ) {
    this.prospectiveStudentsQuery = prospectiveStudentsQuery || '';
    this.parentsOfProspectsQuery = parentsOfProspectsQuery || '';
    this.otherQuery = otherQuery || '';
    this.usaQuery = usaQuery || '';
    this.internationalQuery = internationalQuery || '';
    this.ageQuery = ageQuery || '';
    this.genderQuery = genderQuery || '';
    this.ethnicityQuery = ethnicityQuery || '';
    this.intendedLevelOfStudyQuery = intendedLevelOfStudyQuery || '';
    this.entryTermQuery = entryTermQuery || '';
    this.intendedMajorQuery = intendedMajorQuery || '';
    this.gpaQuery = gpaQuery || '';
    this.testScoresQuery = testScoresQuery || '';
    this.dateRegisteredQuery = dateRegisteredQuery || '';
    this.relativeEngagementQuery = relativeEngagementQuery || '';
    this.totalTimeSpentQuery = totalTimeSpentQuery || '';
    this.scheduledVisitQuery = scheduledVisitQuery || '';
    this.appliedQuery = appliedQuery || '';
    this.activityWithInstitutionQuery = activityWithInstitutionQuery || '';
    this.activityWithEABQuery = activityWithEABQuery || '';
    this.listMembershipQuery = listMembershipQuery || '';
    this.locationsQuery = locationsQuery || '';
    this.queryIsIncongruent = queryIsIncongruent || false;
  }
}
